// extracted by mini-css-extract-plugin
export var captcha = "custom-form-module--captcha--8092c";
export var customForm = "custom-form-module--customForm--efbb2";
export var fileField = "custom-form-module--fileField--22957";
export var formPart = "custom-form-module--formPart--7231c";
export var formatHint = "custom-form-module--formatHint--2f32f";
export var globalError = "custom-form-module--globalError--2a843";
export var select = "custom-form-module--select--dab73";
export var submitButton = "custom-form-module--submitButton--5c78c";
export var successMessage = "custom-form-module--successMessage--175f5";
export var textField = "custom-form-module--textField--92552";
export var title = "custom-form-module--title--487a7";